<template>
  <div>
    <div class="mt-2">
      <div class="p-3 bg-white header-detail">
        <b-row>
          <b-col sm="8">
            <b-row>
              <b-col sm="3">
                <span>หมายเลข Batch ID:</span>
              </b-col>
              <b-col sm="9" class="pl-0">
                <span>{{ detail.batchNo }}</span>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="2" class="header-padding"><span>สถานะ:</span></b-col>
          <b-col sm="2" class="text-right"
            ><span>{{ detail.batchStatus }}</span></b-col
          >
        </b-row>
        <b-row class="mt-2">
          <b-col sm="8">
            <b-row>
              <b-col sm="3">
                <span>วันที่สร้าง:</span>
              </b-col>
              <b-col sm="9" class="pl-0">
                <div class="date-text">
                  {{ new Date(detail.dateOrder) | moment($formatDateTime) }}
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="2" class="header-padding"
            ><span>ช่องทางการสั่งซื้อ:</span></b-col
          >
          <b-col sm="2" class="text-right">
            <span>{{ detail.sellerShop }}</span>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col sm="8">
            <b-row>
              <b-col sm="3">
                <span>อัพเดทล่าสุด:</span>
              </b-col>
              <b-col sm="9" class="pl-0">
                <div class="date-text">
                  {{ new Date(detail.updatedTime) | moment($formatDateTime) }}
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="2" class="header-padding"
            ><span>ช่องทางการจัดส่ง:</span></b-col
          >
          <b-col sm="2" class="text-right">
            <span>{{ detail.shipping }}</span>
          </b-col>
        </b-row>
      </div>
      <div class="mt-2 p-3 bg-white header-detail">
        <b-row>
          <b-col sm="6">
            <b-row>
              <b-col sm="12">
                <b-row>
                  <b-col sm="4">
                    <span>จำนวนรายการสั่งซื้อ:</span>
                  </b-col>
                  <b-col sm="8" class="pl-0">
                    <span>{{ detail.countOrder }}/{{ detail.totalOrder }}</span>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="12" class="mt-2">
                <b-row>
                  <b-col sm="4">
                    <span>จำนวนสินค้า:</span>
                  </b-col>
                  <b-col sm="8" class="pl-0">
                    <span
                      >{{ detail.countProduct }}/{{ detail.totalProduct }}</span
                    >
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="6" class="m-auto text-right">
            <b-dropdown
              id="dropdown-product"
              text="พิมพ์เอกสาร"
              class="ml-2 dropdown-option"
            >
              <template v-slot:button-content>
                <b-icon icon="printer"></b-icon> พิมพ์เอกสาร
              </template>
              <b-dropdown-item
                :disabled="orderSelectList.length == 0"
                @click="printPDF('exportshippinglabelAndBill')"
              >
                พิมพ์ Shipping Label และ Bill
              </b-dropdown-item>
              <b-dropdown-item
                :disabled="orderSelectList.length == 0"
                @click="printPDF('exportshippinglabel')"
              >
                พิมพ์ Shipping Label
              </b-dropdown-item>
              <b-dropdown-item
                :disabled="orderSelectList.length == 0"
                @click="printPDF('GroupBill')"
              >
                พิมพ์ Group Bill
              </b-dropdown-item>
              <b-dropdown-item
                :disabled="orderSelectList.length == 0"
                @click="printPDF('exportbill')"
              >
                พิมพ์ Bill
              </b-dropdown-item>
            </b-dropdown>
            <b-dropdown
              right
              id="dropdown-product"
              text="ตัวเลือกเพิ่มเติม"
              class="ml-2 dropdown-option"
            >
              <b-dropdown-item @click="exportBatch">
                นำออกข้อมูล Batch Excel
              </b-dropdown-item>
              <b-dropdown-item
                :disabled="orderSelectList.length == 0"
                @click="exportOrder"
              >
                นำออกข้อมูล Order Excel
              </b-dropdown-item>
            </b-dropdown>
          </b-col>
        </b-row>
      </div>
      <div class="mt-2 header-purple">
        <div>
          <p class="mb-0">
            <strong> รายการคำสั่งซื้อ / สินค้า </strong>
          </p>
        </div>
      </div>
      <div class="p-3 bg-white">
        <div class="mb-3">
          <h3 class="font-weight-bold">รายการคำสั่งซื้อ</h3>
        </div>
        <b-row>
          <b-col sm="4">
            <b-input-group class="panel-input-serach">
              <b-form-input
                v-model="filter.Search"
                class="input-serach"
                placeholder="ค้นหาหมายเลขคำสั่งซื้อ"
                @keyup.enter="handlePushMessage"
              ></b-form-input>
              <b-input-group-prepend>
                <span class="icon-input m-auto pr-2">
                  <font-awesome-icon
                    icon="search"
                    title="View"
                    @click="onSubmitFilter"
                  />
                </span>
              </b-input-group-prepend>
            </b-input-group>
          </b-col>
          <b-col sm="8" class="text-right">
            <b-button
              class="btn-filter ml-2"
              @click="openMoveOrder"
              :disabled="orderSelectList.length == 0"
            >
              <span class="d-none d-sm-inline">ย้ายไปยัง </span>
            </b-button>
            <b-button v-b-toggle.sidebar-filter class="btn-filter ml-2">
              <font-awesome-icon
                icon="filter"
                title="filter-btn"
                class="main-color mr-0 mr-sm-1"
              />
              <span class="d-none d-sm-inline">ตัวกรอง</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
      <div class="px-3 bg-white">
        <b-row class="no-gutters px-3 px-sm-0">
          <b-col sm="12">
            <b-table
              responsive
              striped
              sticky-header="400px"
              :thStyle="tableHeaderStyle"
              class="text-center table-list"
              :fields="fieldsOrder"
              :items="orderList"
              :busy="isBusyOrder"
              show-empty
              empty-text="ไม่พบข้อมูล"
            >
              <template v-slot:head(orderId)="">
                <b-form-group class="cb-table">
                  <b-form-checkbox
                    v-model="selectItemAll"
                    @change="checkOrderHeader"
                  ></b-form-checkbox>
                </b-form-group>
              </template>
              <template v-slot:cell(orderId)="data">
                <b-form-group class="cb-table">
                  <b-form-checkbox
                    :value="data.item.orderId"
                    v-model="orderSelectList"
                  ></b-form-checkbox>
                </b-form-group>
              </template>
              <template v-slot:cell(receiptNo)="data">
                <div class="table-row">
                  <span class="m-0">
                    <font-awesome-icon
                      icon="circle"
                      :class="[
                        'flag',
                        data.item.datetimeColor === 3
                          ? 'text-danger'
                          : data.item.datetimeColor === 1
                          ? 'text-success'
                          : 'text-warning',
                      ]"
                    />
                    {{ data.item.receiptNo }}
                  </span>
                </div>
              </template>
              <template v-slot:cell(invoiceNo)="data">
                <div>
                  <p class="m-0" v-if="data.item.invoiceNo">
                    {{ data.item.invoiceNo }}
                  </p>
                  <p v-else class="m-0">-</p>
                </div>
              </template>
              <template v-slot:cell(createdTime)="data">
                <div class="date-text" v-if="data.item.createdTime">
                  {{
                    new Date(data.item.createdTime) | moment($formatDateTime)
                  }}
                </div>
                <div class="date-text" v-else><p class="m-0">-</p></div>
              </template>
              <template #cell(shipping)="data">
                <p class="m-0">
                  {{ data.item.shipping }}
                </p>
                <p class="m-0">
                  {{ data.item.trackingNo }}
                </p>
              </template>
              <template v-slot:cell(trackingNo)="data">
                <div>
                  <p class="m-0">
                    {{ data.item.trackingNo || "-" }}
                  </p>
                </div>
              </template>
              <template v-slot:cell(sellerShop)="data">
                <div>
                  <p class="m-0">
                    {{ data.item.sellerShop || "-" }}
                  </p>
                </div>
              </template>
              <template v-slot:cell(totalProduct)="data">
                <div>
                  <p class="m-0" v-if="data.item.totalProduct">
                    {{ data.item.totalProduct | numeral("0,0") }}
                  </p>
                  <p v-else class="m-0">-</p>
                </div>
              </template>
              <template v-slot:cell(manage)="data">
                <b-button variant="link" class="px-1 py-0">
                  <router-link
                    :to="
                      '/order/details/' +
                      data.item.orderId +
                      '?brandID=' +
                      $route.query.brandID
                    "
                    class="text-purple-1"
                  >
                    <u>ดูรายละเอียด</u>
                  </router-link>
                </b-button>
              </template>
              <template v-slot:table-busy>
                <div class="text-center text-black my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="ml-2">Loading...</strong>
                </div>
              </template>
            </b-table>
          </b-col>
          <b-col sm="12">
            <b-row class="px-3 pb-3">
              <b-col class="form-inline justify-content-end">
                <div class="d-sm-flex mr-3">
                  <b-pagination
                    v-model="filter.Skip"
                    :total-rows="rows"
                    :per-page="filter.Take"
                    class="m-md-0 page-item"
                    @change="pagination"
                  ></b-pagination>
                </div>
                <b-form-select
                  v-model="filter.Take"
                  @change="hanndleChangePerpage"
                  :options="pageOptions"
                ></b-form-select>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" class="mt-4">
            <div class="mb-3">
              <h3 class="font-weight-bold">รายการสินค้า</h3>
            </div>
            <b-table
              responsive
              striped
              sticky-header="400px"
              :thStyle="tableHeaderStyle"
              class="text-center table-list"
              :fields="fieldsProduct"
              :items="productList"
              :busy="isBusyProduct"
              show-empty
              empty-text="ไม่พบข้อมูล"
            >
              <template v-slot:cell(productImage)="data">
                <div>
                  <div
                    v-if="data.item.productImage"
                    class="table-image"
                    v-bind:style="{
                      'background-image': 'url(' + data.item.productImage + ')',
                    }"
                  ></div>
                  <div v-else>-</div>
                </div>
              </template>
              <template v-slot:cell(sku)="data">
                <div class="text-left">
                  <p class="m-0" v-if="data.item.sku">
                    {{ data.item.sku }}
                  </p>
                  <p v-else class="m-0">-</p>
                </div>
              </template>
              <template v-slot:cell(name)="data">
                <div class="text-left">
                  <p class="m-0" v-if="data.item.name">
                    {{ data.item.name }}
                  </p>
                  <p v-else class="m-0">-</p>
                </div>
              </template>
              <template v-slot:cell(quantity)="data">
                <div class="table-row">
                  <p class="m-0" v-if="data.item.quantity >= 0">
                    {{ data.item.quantity | numeral("0,0") }}/{{
                      data.item.totalQuantity | numeral("0,0")
                    }}
                  </p>
                  <p v-else class="m-0">-</p>
                </div>
              </template>
              <template v-slot:cell(totalOrder)="data">
                <p class="m-0" v-if="data.item.totalOrder">
                  {{ data.item.totalOrder | numeral("0,0") }}
                </p>
                <p v-else class="m-0">-</p>
              </template>

              <template v-slot:cell(perPrice)="data">
                <p class="m-0 price-text" v-if="data.item.perPrice">
                  ฿ {{ data.item.perPrice | numeral("0,0.00") }}
                </p>
                <p v-else class="m-0 price-text">-</p>
              </template>
              <template v-slot:table-busy>
                <div class="text-center text-black my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="ml-2">Loading...</strong>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </div>
    </div>
    <b-sidebar
      id="sidebar-filter"
      backdrop
      shadow
      backdrop-variant="dark"
      right
      ref="filterSidebar"
      aria-labelledby="sidebar-filter-title"
      no-header
      @change="toggleBodyScrollbar"
    >
      <template #default="{ hide }">
        <div class="p-3 sidebar-filter-header d-flex justify-content-between">
          <h4 id="sidebar-filter-title" class="m-0">ตัวกรอง</h4>
          <font-awesome-icon
            class="my-auto pointer"
            icon="times-circle"
            color="#FFFFFF"
            @click="hide"
          />
        </div>
        <div class="px-3 py-2">
          <div class="mt-2">
            <b-input-group class="panel-input-serach">
              <b-form-input
                id="product-search"
                class="input-serach"
                placeholder="ค้นหาหมายเลขคำสั่งซื้อ/Batch ID"
                v-model="filter.batchNo"
              ></b-form-input>
              <b-input-group-prepend>
                <span class="icon-input m-auto pr-2">
                  <font-awesome-icon icon="search" title="View" />
                </span>
              </b-input-group-prepend>
            </b-input-group>
          </div>

          <div class="mt-3">
            <div class="font-weight-bold mb-2">วันที่สร้าง</div>
            <div :class="['input-container']">
              <datetime
                :input-style="styleDatetime"
                v-model="filter.createDate"
                placeholder="วว / ดด / ปป"
                ref="createDate"
              >
              </datetime>
              <div
                class="icon-container text-right"
                @click="$refs.createDate.isOpen = true"
              >
                <font-awesome-icon icon="calendar-alt" color="#B41BB4" />
              </div>
            </div>
          </div>

          <!-- <div class="mt-3">
            <div class="font-weight-bold mb-2">ช่องทางการซื้อ</div>
            <b-form-group>
              <b-form-checkbox
                v-for="(channel, index) in saleChannelConfigList"
                :key="index"
                :value="channel.id"
                class="mb-2"
                v-model="filter.ChannelId"
                >{{ channel.name }}</b-form-checkbox
              >
            </b-form-group>
          </div>

          <div class="mt-3">
            <div class="font-weight-bold mb-2">ช่องทางการจัดส่ง</div>
            <b-form-group>
              <b-form-checkbox
                v-for="(delivery, index) in deliveryChannalConfigList"
                :key="index"
                :value="delivery.id"
                class="mb-2"
                v-model="filter.ShppingId"
                >{{ delivery.name }}</b-form-checkbox
              >
            </b-form-group>
          </div> -->
          <div class="mt-3">
            <div class="font-weight-bold mb-2">สีรายการสั่งซื้อ</div>
            <b-form-group>
              <b-form-checkbox
                v-for="(color, index) in orderColorConfigList"
                :key="index"
                :value="color.id"
                class="mb-2"
                v-model="filter.PaymentTimeId"
                ><font-awesome-icon
                  icon="circle"
                  :class="[
                    'flag',
                    color.id === 3
                      ? 'text-danger'
                      : color.id === 1
                      ? 'text-success'
                      : 'text-warning',
                  ]"
                />
                {{ color.name }}</b-form-checkbox
              >
            </b-form-group>
          </div>
        </div>
      </template>

      <template #footer>
        <div
          class="d-flex justify-content-between shadow align-items-center border-top"
        >
          <div class="w-100">
            <b-button
              block
              size="lg"
              variant="light"
              class="text-dark w-100 border-radius-0 btn-clear-filter"
              @click="clearFilter"
              >ล้างตัวกรอง</b-button
            >
          </div>
          <div class="w-100">
            <b-button
              block
              size="lg"
              variant="light"
              class="text-body btn-main w-100 border-radius-0"
              @click="onSubmitFilter"
            >
              ยืนยัน
            </b-button>
          </div>
        </div>
      </template>
    </b-sidebar>
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import { BIcon } from "bootstrap-vue";
import InputText from "@/components/inputs/InputText";
import ModalLoading from "@/components/modal/alert/ModalLoading";
export default {
  name: "BatchDetailPanel",
  components: { BIcon, InputText, ModalLoading },
  props: {
    id: {
      type: Number,
      isRequired: true,
    },
    detail: {
      type: Object,
      isRequired: true,
    },
  },
  data() {
    return {
      orderList: [],
      productList: [],
      selectItemAll: false,
      orderSelectList: [],
      allIdList: [],
      filter: {
        BatchId: this.id,
        Search: "",
        CreateDate: "",
        ChannelId: [],
        ShppingId: [],
        PaymentTimeId: [1, 2, 3],
        Skip: 1,
        Take: 10,
      },
      rows: 0,
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
      saleChannelConfigList: [],
      deliveryChannalConfigList: [],
      orderColorConfigList: [
        {
          id: 1,
          name: "สีเขียว",
        },
        {
          id: 2,
          name: "สีเหลือง",
        },
        {
          id: 3,
          name: "สีแดง",
        },
      ],
      fieldsOrder: [
        {
          key: "orderId",
          label: "",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "5%",
          },
        },

        {
          key: "receiptNo",
          label: "หมายเลขบิล",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "15%",
          },
        },
        {
          key: "invoiceNo",
          label: "หมายเลขคำสั่งซื้อ",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "15%",
          },
        },
        {
          key: "createdTime",
          label: "วันที่สั่งซื้อ",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "10%",
          },
        },
        {
          key: "paymentName",
          label: "ช่องทางการชำระเงิน",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "12%",
          },
        },
        {
          key: "shipping",
          label: "ช่องทางการจัดส่ง / หมายเลขพัสดุ",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "13%",
          },
        },
        // {
        //   key: "sellerShop",
        //   label: "ช่องทาง",
        //   class: "text-nowrap",
        //   thStyle: {
        //     "padding-left": "0px !important",
        //     "padding-right": "0px !important",
        //     "background-color": "#d1d0e6 !important",
        //     width: "10%",
        //   },
        // },
        {
          key: "totalProduct",
          label: "จำนวนสินค้า",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "10%",
          },
        },
        {
          key: "documentStatus",
          label: "สถานะ",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "15%",
          },
        },
        {
          key: "status",
          label: "สถานะคำสั่งซื้อ",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "15%",
          },
        },
        {
          key: "manage",
          label: "",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "10%",
          },
        },
      ],
      fieldsProduct: [
        {
          key: "productImage",
          label: "รูปภาพ",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "15% !important",
          },
        },
        {
          key: "sku",
          label: "SKU",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "20% !important",
          },
        },
        {
          key: "name",
          label: "ชื่อสินค้า",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "25% !important",
          },
        },
        {
          key: "quantity",
          label: "จำนวนชิ้น",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "10% !important",
          },
        },
        {
          key: "totalOrder",
          label: "จำนวนรายการสั่งซื้อ",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "15% !important",
          },
        },
        {
          key: "perPrice",
          label: "ราคาต่อหน่วย",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "15% !important",
          },
        },
      ],
      tableHeaderStyle: {
        "background-color": "#d1d0e6 !important",
      },
      styleDatetime: {
        width: "100%",
        border: "none",
      },
      isBusyOrder: false,
      isBusyProduct: false,
    };
  },
  watch: {
    orderSelectList: {
      handler(val) {
        this.selectItemAll =
          this.orderSelectList.length == this.allIdList.length ? true : false;
      },
    },
    listAllDataId: {
      handler(val) {
        this.selectItemAll =
          this.orderSelectList.length == this.allIdList.length ? true : false;
      },
    },
  },
  async created() {
    await this.getOrderList();
    await this.getProductList();
    await this.getFilterList();
  },
  methods: {
    toggleBodyScrollbar(visible) {
      const body = document.getElementsByTagName("body")[0];

      if (visible) {
        body.classList.add("overflow-hidden");
      } else {
        body.classList.remove("overflow-hidden");
      }
    },
    getOrderList() {
      this.isBusyOrder = true;
      this.axios
        .post(`${this.$baseUrl}/Batch/Detail/Order`, this.filter)
        .then((data) => {
          this.orderList = data.detail.orders;
          this.rows = data.detail.count;
          this.allIdList = data.detail.id;
          this.isBusyOrder = false;
        });
    },
    getProductList() {
      this.isBusyProduct = true;
      this.axios
        .get(`${this.$baseUrl}/Batch/Detail/Product/${this.id}`)
        .then((data) => {
          this.productList = data.detail;
          this.isBusyProduct = false;
        });
    },
    getFilterList() {
      this.sellerIdAll = [];
      this.shippingIdAll = [];
      this.axios.get(`${this.$baseUrl}/batch/seller/list`).then((data) => {
        this.saleChannelConfigList = data.detail;
        this.axios.get(`${this.$baseUrl}/batch/shipping/list`).then((data) => {
          this.deliveryChannalConfigList = data.detail;
          this.saleChannelConfigList.forEach((e) => {
            this.sellerIdAll.push(e.id);
          });
          this.deliveryChannalConfigList.forEach((e) => {
            this.shippingIdAll.push(e.id);
          });
          this.filter.ChannelId = this.sellerIdAll;
          this.filter.ShppingId = this.shippingIdAll;
        });
      });
    },
    handlePushMessage(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.onSubmitFilter();
      }
    },
    onSubmitFilter() {
      const getSidebar = this.$refs.filterSidebar.isOpen;

      this.filter.Search = getSidebar
        ? this.filter.batchNo
        : this.filter.Search;

      this.filter.Skip = 1;
      this.orderSelectList = [];
      this.getOrderList();
      this.$refs.filterSidebar.hide();
    },
    openMoveOrder() {
      let orderSelectArr = [];

      for (let i = 0; i < this.orderList.length; i++) {
        const x = this.orderList[i];
        let isCheck = false;

        for (let j = 0; j < this.orderSelectList.length; j++) {
          const y = this.orderSelectList[j];
          if (x.orderId == y) {
            isCheck = true;
            break;
          }
        }

        if (isCheck) {
          orderSelectArr.push(x);
        }
      }

      let final = {
        orderSelectList: this.orderSelectList,
        orderSelectArr: orderSelectArr,
      };

      this.$emit("openMoveOrder", final);
    },
    checkOrderHeader(value) {
      if (value) {
        this.orderSelectList = this.allIdList;
      } else {
        this.orderSelectList = [];
      }
    },
    pagination(Page) {
      this.filter.Skip = Page;
      this.onSubmitFilter();
    },
    hanndleChangePerpage(value) {
      this.filter.Skip = 1;
      this.filter.Take = value;
      this.onSubmitFilter();
    },
    clearFilter() {
      this.filter = {
        BatchId: this.id,
        Search: "",
        CreateDate: "",
        ChannelId: [],
        ShppingId: [],
        PaymentTimeId: [1, 2, 3],
        Skip: 1,
        Take: 10,
      };
      this.filter.ChannelId = this.sellerIdAll;
      this.filter.ShppingId = this.shippingIdAll;
      this.onSubmitFilter();
    },
    async exportBatch() {
      this.$refs.modalLoading.show();
      this.axios
        .post(
          `${this.$baseUrl}/Batch/ExportBatchListExcel`,
          { BatchId: [this.id] },
          { responseType: "blob" }
        )
        .then((data) => {
          var fileURL = window.URL.createObjectURL(new Blob([data]));
          var fileLink = document.createElement("a");
          var dateExcel = this.$moment().format("DDMMYYYYhhmmss");
          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            `export-batch` + dateExcel + `.xlsx`
          );
          document.body.appendChild(fileLink);
          fileLink.click();
          this.$refs.modalLoading.hide();
        });
    },
    async exportOrder() {
      this.$refs.modalLoading.show();
      this.axios
        .post(
          `${this.$baseUrl}/Batch/ExportOrderListExcel`,
          { OrderId: this.orderSelectList },
          { responseType: "blob" }
        )
        .then((data) => {
          var fileURL = window.URL.createObjectURL(new Blob([data]));
          var fileLink = document.createElement("a");
          var dateExcel = this.$moment().format("DDMMYYYYhhmmss");
          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            `export-order` + dateExcel + `.xlsx`
          );
          document.body.appendChild(fileLink);
          fileLink.click();
          this.$refs.modalLoading.hide();
        });
    },
    async printPDF(path) {
      this.$refs.modalLoading.show();
      this.axios
        .post(
          `${this.$baseUrl}/batch/ExportPaper/${path}`,
          this.orderSelectList,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response]));
          var fileLink = document.createElement("a");
          var datePDF = this.$moment().format("DDMMYYYYhhmmss");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", `document-` + datePDF + `.pdf`);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.$refs.modalLoading.hide();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .dropdown-menu-right {
  width: 193.8px;
  padding: 0px;
}
.header-padding {
  padding-left: 40px;
}
.picture-text {
  min-width: 60px;
}
.price-text {
  white-space: nowrap;
}
.GWP {
  background-color: #e3e2f2;
  color: #8078c6;
}
.pic-contain {
  min-width: 80px !important;
}
.pic-box {
  max-height: 80px !important;
  background-size: cover !important;
  background-repeat: no-repeat;
  background-position: right top;
}
.pic-table {
  max-height: 65px !important;
}
.cb-table {
  position: relative;
  margin-left: 15px;
  padding-top: 15px;
}
.input-container {
  display: flex;
  padding: 0.5rem;
  border: 1px solid #bcbcbc;
  border-radius: 4px;
  align-items: center;
  justify-content: space-between;
}
.header-detail {
  font-size: 15px;
  font-weight: bold;
}
</style>
